import React from 'react'
import Img from "gatsby-image"
import ReactTypingEffect from '../../ReactTyping'

import Lottie from 'lottie-react-web'
import { useStaticQuery, graphql, Link } from "gatsby"
import { injectIntl } from 'react-intl';

import CloseIcon from "../../../assets/close.svg"
import animationData from '../../../animations/guru.json'
import * as S from './Main.styled'
import generateLink from '../../../utils/generateLink'

const Main = ({ intl }) => {
  const [showVideo, setShowVideo] = React.useState(false)
  const happyPress = useKeyPress('Escape');

  React.useEffect(() => {
    if (showVideo) {
      setShowVideo(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [happyPress])

  const images = useStaticQuery(graphql`
    query {
      play: file(relativePath: { eq: "play.jpg" }) {
        childImageSharp {
          fixed(width: 107) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      skillcore: file(relativePath: { eq: "skillcore_black.png" }) {
        childImageSharp {
          fixed(width: 74) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      james: file(relativePath: { eq: "james_black.png" }) {
        childImageSharp {
          fixed(width: 110) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      cornershop: file(relativePath: { eq: "logo-cornershop.png" }) {
        childImageSharp {
          fixed(width: 110) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      decolar: file(relativePath: { eq: "decolar-logo-black.png" }) {
        childImageSharp {
          fixed(width: 110) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      rana: file(relativePath: { eq: "rana_black.png" }) {
        childImageSharp {
          fixed(width: 128) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      quadritech: file(relativePath: { eq: "quadritech_black.png" }) {
        childImageSharp {
          fixed(width: 128) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  const handleShowVideo = () => {
    setShowVideo(v => !v)
  }

  const idVideo = () => {
    if (intl.locale === 'pt-br') {
      return 'ricCVeaPOec'
    }

    return 'mSz-sZMljFQ';
  }

  return (
    <>
      <S.Main id="home">
        <div className="grid container">

          <div className="main-content">
            <h1 className="primary">
              {intl.messages.main.primaryText}
              {typeof window !== `undefined` &&
                <ReactTypingEffect 
                  speed={30} 
                  eraseSpeed={30} 
                  typingDelay={100} 
                  eraseDelay={4000} 
                  text={
                    intl.locale === 'en'
                      ? [intl.messages.main.types.pix, intl.messages.main.types.eletronictransfer, intl.messages.main.types.payin_qrcode]
                      : [intl.messages.main.types.eletronictransfer, intl.messages.main.types.pix, intl.messages.main.types.payin_qrcode, intl.messages.main.types.payin_boleto ,intl.messages.main.types.dq]
                  }
                />
              }
            </h1>
            <h3 className="secondary">{intl.messages.main.secondaryText}</h3>
            
            <div className="ctas">
              <a target="_blank" href={intl.locale === "en" ? "https://marketing.wepayout.co/whitepaper-wepayout-en" : "https://marketing.wepayout.co/whitepaper-wepayout"} rel="noreferrer"><button className="button button--primary">{intl.messages.main.buttonStart}</button></a>
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
              {/* <button onClick={() => handleShowVideo()} className="button-play">
                <Img fixed={images.play.childImageSharp.fixed} />
                <div className="label">{intl.messages.main.watchVideo}</div>
              </button> */}
            </div>
          </div>

          <div className="feature-image">
            <Lottie
              options={{
                animationData: animationData
              }}
            />
          </div>
        </div>
      </S.Main>
      <S.Customers>
        <div className="container grid">
          <div className="wrapper">
            <Link to={generateLink({ link: intl.locale === 'en' ? '/customers' : '/clientes', locale: intl.locale })} style={{ textDecoration: 'none' }}>
              
              <div className="table-customers">
                <div className="table-customers__item">
                  <Img fixed={images.decolar.childImageSharp.fixed} alt="Decolar" />
                </div>
                <div className="table-customers__item">
                  <Img fixed={images.cornershop.childImageSharp.fixed} alt="Cornershop" />
                </div>
                <div className="table-customers__item">
                  <Img fixed={images.skillcore.childImageSharp.fixed} alt="SkillCore" />
                </div>
                <div className="table-customers__item">
                  <Img fixed={images.rana.childImageSharp.fixed} alt="Rana Express" />
                </div>
                <div className="table-customers__item">
                  <Img fixed={images.james.childImageSharp.fixed} alt="James" />
                </div>
                <div className="table-customers__item">
                  <Img fixed={images.quadritech.childImageSharp.fixed} alt="Quadritech" />
                </div>
                <div className="table-customers__overlay"></div>
              </div>
              <div className="show-customers">
                <button className="button button--primary">{intl.messages.products.customers}</button>
              </div>
            </Link>
          </div>
        </div>
      </S.Customers>
      {showVideo &&
        <S.Video>
          <div className="video">
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <button onClick={() => handleShowVideo()}><CloseIcon /></button>
            <div className='embed-container'>
              <iframe 
                title="Video"
                src={`https://www.youtube-nocookie.com/embed/${idVideo()}?autoplay=1&loop=1&cc_load_policy=1&disablekb=1&color=white&controls=0`}
                frameborder='0' 
                allowfullscreen>
              </iframe>
            </div>
          </div>
        </S.Video>
      }
    </>
  )
}

function useKeyPress(targetKey) {
  // State for keeping track of whether key is pressed
  const [keyPressed, setKeyPressed] = React.useState(false);

  // If pressed key is our target key then set to true
  function downHandler({ key }) {
    if (key === targetKey) {
      setKeyPressed(true);
    }
  }

  // If released key is our target key then set to false
  const upHandler = ({ key }) => {
    if (key === targetKey) {
      setKeyPressed(false);
    }
  };

  // Add event listeners
  React.useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return keyPressed;
}

export default injectIntl(Main);